import { combineReducers } from 'redux';
import { authentication } from './authentication.reducer';
import { alert } from './alert.reducer';
import { objs } from './objs.reducer';
import notifyReducer from 'react-redux-notify';


const rootReducer = combineReducers({
  authentication,
  alert,
  objs,
  notifications: notifyReducer
 
});

export default rootReducer;